(() => {
  'use strict';
  document.documentElement.classList.replace('no-js', 'js');
  const configNode = document.getElementById('ZavoraConfig');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const strings = config.strings;
  const dialog = document.getElementById('ZavoraCartDialog');
  const container = document.querySelector('[data-z-cart-container]');
  let cart = config.initialCart || { items: [], item_count: 0 };
  let busy = false;
  let opener = null;
  const endpoint = path => path.replace(/\/$/, '') + '.js';
  const status = message => { const node = document.querySelector('[data-z-status]'); if (node) node.textContent = message; };
  const message = (node, text, error = false) => { if (node) { node.textContent = text; node.classList.toggle('z-error', error); } };

  async function request(url, options = {}) {
    const response = await fetch(url, { credentials: 'same-origin', ...options, headers: { Accept: 'application/json', ...options.headers } });
    let data;
    try { data = await response.json(); } catch (_) { throw new Error(strings.error); }
    if (!response.ok || data.status >= 400) throw new Error(typeof data.description === 'string' ? data.description : strings.error);
    return data;
  }
  function selectedLine(form) {
    const id = form.querySelector('[name="id"]')?.value;
    const plan = form.querySelector('[name="selling_plan"]')?.value || '';
    const properties = [...new FormData(form)].filter(([key, value]) => key.startsWith('properties[') && value);
    if (properties.length) return null;
    return cart.items.find(item => String(item.variant_id || item.id) === String(id) && String(item.selling_plan_allocation?.selling_plan?.id || '') === plan && !Object.keys(item.properties || {}).length);
  }
  function syncProductForms() {
    document.querySelectorAll('[data-z-product-form]').forEach(form => {
      const button = form.querySelector('[data-z-add]');
      const option = form.querySelector('[data-z-variant]')?.selectedOptions[0];
      if (!button || !option) return;
      const available = option.dataset.available === 'true';
      const exists = selectedLine(form);
      const quantity = form.querySelector('[data-z-product-quantity]');
      if (quantity) {
        if (exists) {
          if (!quantity.dataset.cartQuantity || quantity.value === quantity.dataset.cartQuantity) quantity.value = exists.quantity;
          quantity.dataset.cartQuantity = exists.quantity;
        } else if (quantity.dataset.cartQuantity) {
          delete quantity.dataset.cartQuantity;
          quantity.value = quantity.min || '1';
        }
        quantity.disabled = busy;
      }
      const changed = exists && quantity && Number(quantity.value) !== exists.quantity;
      button.disabled = busy || (!available && !exists);
      button.textContent = busy ? strings.adding : exists ? (changed ? strings.updateCart : strings.viewCart) : available ? strings.add : strings.soldOut;
      button.dataset.inCart = exists ? 'true' : 'false';
    });
    document.querySelectorAll('[data-z-cart-count]').forEach(node => { node.textContent = cart.item_count; });
  }
  function setBusy(value) {
    busy = value;
    if (dialog) { dialog.setAttribute('aria-busy', String(value)); dialog.querySelectorAll('button:not([data-z-cart-close]), input').forEach(node => { node.disabled = value; }); }
    syncProductForms();
  }
  function showDialog(trigger) {
    if (!dialog || typeof dialog.showModal !== 'function') { window.location.assign(config.cart); return; }
    if (trigger) opener = trigger;
    if (!dialog.open) dialog.showModal();
    document.body.classList.add('z-drawer-open');
  }
  function closeDialog() { if (dialog?.open) dialog.close(); }
  if (dialog) {
    dialog.addEventListener('close', () => { document.body.classList.remove('z-drawer-open'); if (opener?.isConnected) opener.focus(); });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeDialog();
    });
  }
  function replaceCartHTML(html) {
    if (!html || !container) return false;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const next = parsed.querySelector('[data-z-cart-content]');
    if (!next) return false;
    container.replaceChildren(next);
    return true;
  }
  async function refreshCart(render = true, sections) {
    cart = await request(endpoint(config.cart), { cache: 'no-store' });
    syncProductForms();
    if (render && !replaceCartHTML(sections?.['zavora-cart-content'])) {
      const sectionURL = new URL(config.root, window.location.origin);
      sectionURL.searchParams.set('sections', 'zavora-cart-content');
      const rendered = await request(sectionURL.toString(), { cache: 'no-store' });
      if (!replaceCartHTML(rendered['zavora-cart-content'])) throw new Error(strings.error);
    }
    return cart;
  }
  async function openCart(trigger) {
    showDialog(trigger);
    if (busy) return;
    setBusy(true);
    message(document.querySelector('[data-z-cart-message]'), strings.loading);
    try { await refreshCart(); message(document.querySelector('[data-z-cart-message]'), ''); }
    catch (error) { message(document.querySelector('[data-z-cart-message]'), error.message, true); }
    finally { setBusy(false); }
  }
  async function addProduct(form) {
    if (busy || !form.reportValidity()) return;
    const formMessage = form.querySelector('[data-z-form-message]');
    const button = form.querySelector('[data-z-add]');
    const quantityInput = form.querySelector('[data-z-product-quantity]');
    const desiredQuantity = Number(quantityInput.value);
    const intendedUpdate = button.dataset.inCart === 'true';
    message(formMessage, '');
    setBusy(true);
    let posted = false;
    try {
      // Refresh before the write so an item added in another tab is not added twice.
      await refreshCart(false);
      const existing = selectedLine(form);
      if (!existing) {
        // Enabling quantity is necessary because disabled fields are omitted by FormData.
        const quantity = form.querySelector('[data-z-product-quantity]');
        if (quantity) quantity.disabled = false;
        const data = new FormData(form);
        data.set('quantity', desiredQuantity);
        data.set('sections', 'zavora-cart-content');
        data.set('sections_url', window.location.pathname);
        const result = await request(endpoint(config.cartAdd), { method: 'POST', body: data });
        posted = true;
        const added = result.items || [result];
        added.forEach(item => { if (item.key) cart.items.push(item); });
        // Mark the product immediately, even if the subsequent rendering request fails.
        cart.item_count = cart.items.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
        syncProductForms();
        await refreshCart(true, result.sections);
        message(formMessage, strings.added);
        status(strings.added);
      } else {
        if (intendedUpdate && desiredQuantity !== existing.quantity) {
          const result = await request(endpoint(config.cartChange), {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: existing.key, quantity: desiredQuantity, sections: ['zavora-cart-content'], sections_url: window.location.pathname })
          });
          cart = result;
          await refreshCart(true, result.sections);
          message(formMessage, strings.updated);
          status(strings.updated);
        } else await refreshCart(true);
      }
      const confirmed = selectedLine(form);
      if (confirmed) { quantityInput.value = confirmed.quantity; quantityInput.dataset.cartQuantity = confirmed.quantity; }
      showDialog(button);
      message(document.querySelector('[data-z-cart-message]'), '');
    } catch (error) {
      // No automatic POST retry: a lost response might already have changed the cart.
      try { await refreshCart(true); } catch (_) { /* Preserve the last known cart. */ }
      message(formMessage, error.message, true);
      if (posted || selectedLine(form)) showDialog(button);
    } finally { setBusy(false); }
  }
  async function changeQuantity(row, quantity) {
    if (busy || !Number.isInteger(quantity) || quantity < 0) return;
    const oldKey = row.dataset.zLineKey;
    setBusy(true);
    message(document.querySelector('[data-z-cart-message]'), '');
    try {
      const result = await request(endpoint(config.cartChange), {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: oldKey, quantity, sections: ['zavora-cart-content'], sections_url: window.location.pathname })
      });
      cart = result;
      await refreshCart(true, result.sections);
      status(strings.updated);
    } catch (error) {
      try { await refreshCart(); } catch (_) { /* Keep the error visible and never repeat a write. */ }
      message(document.querySelector('[data-z-cart-message]'), error.message, true);
    } finally { setBusy(false); }
  }
  function showMedia(section, id) {
    if (!id || !section.querySelector(`[data-z-media="${CSS.escape(String(id))}"]`)) return;
    section.querySelectorAll('[data-z-media]').forEach(pane => {
      const hide = pane.dataset.zMedia !== String(id);
      pane.hidden = hide;
      if (hide) {
        pane.querySelectorAll('video').forEach(video => video.pause());
        pane.querySelectorAll('iframe').forEach(frame => { if (frame.contentWindow) frame.src = frame.src; });
      }
    });
    section.querySelectorAll('[data-z-thumb]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.zThumb === String(id))));
  }
  function changeVariant(select, updateURL = true) {
    const option = select.selectedOptions[0];
    const section = select.closest('[data-z-product]');
    if (!section || !option) return;
    section.querySelector('[data-z-price]').textContent = option.dataset.price;
    const compare = section.querySelector('[data-z-compare]');
    compare.textContent = option.dataset.compare; compare.hidden = !option.dataset.compare;
    const unit = section.querySelector('[data-z-unit]');
    unit.textContent = option.dataset.unit; unit.hidden = !option.dataset.unit;
    const quantity = section.querySelector('[data-z-product-quantity]');
    quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.step || '1';
    if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
    quantity.disabled = false; quantity.value = quantity.min;
    delete quantity.dataset.cartQuantity;
    showMedia(section, option.dataset.media);
    message(section.querySelector('[data-z-form-message]'), '');
    if (updateURL) { const url = new URL(window.location.href); url.searchParams.set('variant', select.value); history.replaceState({}, '', url); }
    syncProductForms();
  }
  // Keep a mouse/touch step click from first blurring the edited input and
  // submitting its old value. The click commits the edited value plus the step.
  document.addEventListener('pointerdown', event => {
    if (event.target.closest('[data-z-quantity-step], [data-z-remove]')?.closest('#ZavoraCartDialog')) event.preventDefault();
  });
  document.addEventListener('input', event => {
    if (event.target.matches('[data-z-product-quantity]')) syncProductForms();
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' && event.target.matches('[data-z-cart-quantity]') && event.target.closest('#ZavoraCartDialog')) {
      event.preventDefault();
      if (event.target.reportValidity()) changeQuantity(event.target.closest('[data-z-line-key]'), Number(event.target.value));
    }
  });
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-z-cart-open]');
    if (open) { if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return; event.preventDefault(); openCart(open); return; }
    if (event.target.closest('[data-z-cart-close]')) { closeDialog(); return; }
    const thumb = event.target.closest('[data-z-thumb]');
    if (thumb) { showMedia(thumb.closest('[data-z-product]'), thumb.dataset.zThumb); return; }
    const remove = event.target.closest('[data-z-remove]');
    if (remove && remove.closest('#ZavoraCartDialog')) { event.preventDefault(); changeQuantity(remove.closest('[data-z-line-key]'), 0); return; }
    const step = event.target.closest('[data-z-quantity-step]');
    if (step) {
      const row = step.closest('[data-z-line-key]'); const input = row.querySelector('[data-z-cart-quantity]');
      const current = Number(input.value); const increment = Number(input.step) || 1; const minimum = Number(input.dataset.min) || 1;
      let next = Math.max(0, current + Number(step.dataset.zQuantityStep) * increment);
      if (Number(step.dataset.zQuantityStep) < 0 && next < minimum) next = 0;
      if (Number(step.dataset.zQuantityStep) > 0 && next < minimum) next = minimum;
      if (input.max && next > Number(input.max)) next = Number(input.max);
      if (next === current) return;
      if (row.closest('#ZavoraCartDialog')) changeQuantity(row, next); else input.value = next;
    }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-z-variant]')) changeVariant(event.target);
    if (event.target.matches('[data-z-plan]')) syncProductForms();
    if (event.target.matches('[data-z-cart-quantity]') && event.target.closest('#ZavoraCartDialog')) {
      if (event.target.reportValidity()) changeQuantity(event.target.closest('[data-z-line-key]'), Number(event.target.value));
    }
  });
  document.addEventListener('submit', event => {
    if (event.target.matches('[data-z-product-form]')) { event.preventDefault(); addProduct(event.target); }
    if (busy && event.target.closest('#ZavoraCartDialog')) event.preventDefault();
  });
  document.addEventListener('shopify:section:load', () => syncProductForms());
  window.addEventListener('pageshow', event => { if (event.persisted) refreshCart(false).catch(() => {}); });
  syncProductForms();
})();
